import { GenericError } from '../../../../common/Error/GenericError';
import { LoadingIndicator } from '../../../../common/LoadingIndicator/LoadingIndicator';
import { CustomerNotificationSettings } from '../CustomerNotificationSettings';
import { useCustomerSettings } from '../useCustomerSettings';

interface CustomerCommunicationPreferencesTabProps {
    companyId: string;
}

export const CustomerCommunicationPreferencesTab = ({ companyId }: CustomerCommunicationPreferencesTabProps) => {
    const customerSettingsQuery = useCustomerSettings(companyId);

    if (customerSettingsQuery.isPending) {
        return <LoadingIndicator />;
    }

    if (customerSettingsQuery.isError) {
        return <GenericError />;
    }

    return <CustomerNotificationSettings customerSettings={customerSettingsQuery.data} customerId={companyId} />;
};
